import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import AllCompetencies from "./components/AllCompetencies";

import AccessDenied from "components/AccessDenied";
import PageContainer from "components/PageContainer";
import { useAuth } from "contexts/auth.context";
import Footer from "examples/Footer";
import { Route, Routes } from "react-router-dom";

function Competencies() {
  const { checkPermission } = useAuth();

  if (
    Object.keys(checkPermission("competency")).filter(
      (key) => checkPermission("competency")[key],
    ).length === 0
  ) {
    return <AccessDenied type="page" />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <PageContainer>
        <Routes>
          <Route
            index
            element={
              <AllCompetencies permissions={checkPermission("competency")} />
            }
          />
        </Routes>
      </PageContainer>

      <Footer />
    </DashboardLayout>
  );
}

export default Competencies;
